import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M6.99998 7.56002C6.99998 6.62002 5.85998 6.14002 5.18998 6.81002L0.70998 11.29C0.31998 11.68 0.31998 12.31 0.70998 12.7L5.18998 17.18C5.85998 17.86 6.99998 17.38 6.99998 16.44C6.99998 16.16 6.88998 15.89 6.68998 15.69L2.99998 12L6.68998 8.31002C6.88998 8.11002 6.99998 7.84002 6.99998 7.56002ZM13 9.00002V7.41002C13 6.52002 11.92 6.07002 11.29 6.70002L6.69998 11.29C6.30998 11.68 6.30998 12.31 6.69998 12.7L11.29 17.29C11.92 17.92 13 17.47 13 16.58V14.9C18 14.9 21.5 16.5 24 20C23 15 20 10 13 9.00002Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.39945 4.60054C5.6201 4.82119 5.6201 5.17893 5.39945 5.39957L2.79897 8.00006L5.39945 10.6005C5.6201 10.8212 5.6201 11.1789 5.39945 11.3996C5.17881 11.6202 4.82107 11.6202 4.60042 11.3996L1.60042 8.39957C1.37977 8.17893 1.37977 7.82119 1.60042 7.60054L4.60042 4.60054C4.82107 4.3799 5.17881 4.3799 5.39945 4.60054ZM14.3059 11.4751C14.0824 11.619 13.7888 11.5877 13.6007 11.3998L13.6005 11.3996L13.6004 11.3995L13.5961 11.3953L13.5749 11.3748C13.5554 11.3561 13.5251 11.3275 13.4847 11.2908C13.404 11.2172 13.2834 11.1112 13.1289 10.9861C12.8188 10.7351 12.3773 10.4116 11.8506 10.119C10.8875 9.58391 9.71996 9.19516 8.565 9.43244L8.565 11.0001C8.565 11.2286 8.42734 11.4346 8.21622 11.5221C8.00509 11.6095 7.76208 11.5612 7.60049 11.3996L4.60049 8.39959C4.49453 8.29363 4.435 8.14992 4.435 8.00008C4.435 7.85023 4.49453 7.70652 4.60049 7.60056L7.60049 4.60056C7.76208 4.43897 8.00509 4.39063 8.21622 4.47808C8.42734 4.56553 8.565 4.77155 8.565 5.00008L8.565 6.45509C10.6956 6.60803 12.1613 7.61265 13.0997 8.61365C13.6062 9.15393 13.9599 9.69309 14.1878 10.0981C14.3019 10.3011 14.3853 10.4718 14.441 10.5941C14.4688 10.6553 14.4898 10.7045 14.5044 10.7397C14.5116 10.7573 14.5173 10.7715 14.5214 10.7819L14.5264 10.7947L14.528 10.7989L14.5286 10.8005L14.5288 10.8011C14.5289 10.8014 14.529 10.8017 14 11.0001L14.529 10.8017C14.6224 11.0507 14.5295 11.3311 14.3059 11.4751Z"
  />
);

export const ReplyAllIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="ReplyAll" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
